import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ComponentProvider from './components/ComponentProvider';

import './theme/global.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ComponentProvider>
      <App />
    </ComponentProvider>
  </React.StrictMode>
);